import { PromptVersion } from 'interfaces';
import copilotServicePingMessages from './copilot-service-ping-messages.json';

interface ICopilotServicePingMessages {
	list: string[];
	prompts: string[];
}
export class CopilotServicePingMessages {
	public static messages(promptVersion: PromptVersion): string[] {
		const messages: ICopilotServicePingMessages[] = copilotServicePingMessages.messages;
		return messages.filter((msg) => msg.prompts.includes(promptVersion))[0].list;
	}
}
